import React from "react";
import "./Template_1.css";

const Template_1_Footer = () => {
  return (
    <footer id="contact" className="Template_1 footer-template-1">
      <div className="Template_1 container">
        <div className="Template_1 footer-content">
          {/* Column 1: About */}
          <div className="Template_1 footer-column">
            <h3>TravelEase</h3>
            <p>
              Making dream vacations accessible to everyone through curated
              experiences and personalized service.
            </p>
            <div className="Template_1 social-links">
              <a href="#">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Destinations */}
          <div className="Template_1 footer-column">
            <h3>Destinations</h3>
            <ul>
              <li>
                <a href="#">Bali, Indonesia</a>
              </li>
              <li>
                <a href="#">Swiss Alps</a>
              </li>
              <li>
                <a href="#">Tokyo, Japan</a>
              </li>
              <li>
                <a href="#">Paris, France</a>
              </li>
              <li>
                <a href="#">Santorini, Greece</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div className="Template_1 footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <a href="#">About Us</a>
              </li>
              <li>
                <a href="#">Terms and Conditions</a>
              </li>
              <li>
                <a href="#">FAQ's</a>
              </li>
              <li>
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Refund Policy</a>
              </li>
              <li>
                <a href="#">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div className="Template_1 footer-column">
            <h3>Contact Us</h3>
            <ul>
              <li>
                <i className="fas fa-phone"></i> +1 (555) 123-4567
              </li>
              <li>
                <i className="fas fa-envelope"></i> info@travelease.com
              </li>
              <li>
                <i className="fas fa-map-marker-alt"></i> 123 Travel St,
                Wanderlust City
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="Template_1 copyright">
          <p>&copy; 2023 TravelEase. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Template_1_Footer;
